import React from 'react';
import { MegaMenu } from './MegaMenu';
import { resolveMegaMenuProps } from './resolveMegaMenuProps';

export { resolveMegaMenuProps } from './resolveMegaMenuProps';

/**
 * Resolved MegaMenu Data JSON, exactly as PolyR passes it from the RenderEntity `content`
 * string and as the hydration bundle reads it back from `data-poly-content`.
 *
 * Accepted fields: `navGroups` (PrimaryNavGroup fields plus `panel` or `panelRef`), a
 * `panels` map keyed by `panelRef`, root `navFooterItems`, and the root MegaMenuProps
 * scalars. Field names follow resolveMegaMenuProps; anything else is ignored.
 */
export interface MegaMenuDataProps {
  /** A Data field. Values are validated by resolveMegaMenuProps at render time. */
  [field: string]: unknown;
}

/**
 * MegaMenuData - registered render adapter for a MegaMenu Data object.
 *
 * Applies resolveMegaMenuProps to the Data JSON and renders MegaMenu, so PolyR SSR and
 * browser hydration run the same transform under the `MegaMenuData` componentType.
 * Not a CMS block: it has no block template and no authorable fields.
 */
export const MegaMenuData: React.FC<MegaMenuDataProps> = (props) => (
  <MegaMenu {...resolveMegaMenuProps(props)} />
);
